<template>
  <!-- 头部字典项搜索 收起、展开 -->
  <!-- 搜索详情 -->
  <div class="cmp-search-dict">
    <div class="search-head">
      

      <el-input class="mb-10" style="width:350px;" placeholder="以分类号/总登记号/藏品名称关键字搜索" @keyup.enter.native="searchTag(listQuery.key,0,listQuery.key)" v-model="listQuery.key">
        <i slot="suffix" class="el-icon-search g-pointer" @click="searchTag(listQuery.key,0,listQuery.key)"></i>
      </el-input>
      <el-button class="ml-20" @click="restTag(dynamicTags)">重置</el-button>

      <!-- 以图搜图 -->
      <!-- <span class="btn-camera-box ml-20" @click="goPhoto">
        <i class="btn-camera" style="left:290px;"></i>
      </span> -->

      
      <span @click="toggleShowHead" ref="spanOne" class="switch g-pointer">
        {{showHead ? '收起' : '更多'}}
        <i :class="showHead?'el-icon-arrow-down':'el-icon-arrow-right'"></i>
      </span>
    </div>

    <div v-if="showHead">
      <div class="sch sch-top">
        <div class="total-type">全部结果 :</div>
        <div>
          <el-tag :key="item.type" v-for="item in headTagChoosed" closable :disable-transitions="false" @close="handleClose(item)" ref="tag" class="tag mb-10">{{item.name}}</el-tag>
        </div>
        <!-- <el-button v-if="headTagChoosed.length > 0"
            type="primary"
            class="reset"
            size="mini"
            style="width:50px"
            @click="restTag(dynamicTags)"
        >重置</el-button>-->
      </div>

      <div class="sch">
        <div class="sch-type">常用年代 :</div>
        <div class="sch-content" :class="{'fix-height': showYearLine}">
          <span v-for="(item,index) in searchYearList" :key="index" @click="searchTag(item.dictCode,2,item.dictName)" :class="{'blue': listQuery.collectYear === item.dictCode}">{{item.dictName}}&nbsp;({{item.collectCount}})</span>

          <span class="switch g-pointer" @click="showYearLine=!showYearLine">
            {{showYearLine ? '更多' : '收起'}}
            <i :class="showYearLine?'el-icon-arrow-right':'el-icon-arrow-down'"></i>
          </span>
        </div>
      </div>

      <div class="sch">
        <div class="sch-type">类别 :</div>
        <div class="sch-content" :class="{'fix-height': showTagLine}">
          <span v-for="(item,index) in searchTypeList" :key="index" @click="searchTag(item.dictCode,1,item.dictName)" :class="{'blue': listQuery.collectType === item.dictCode}">{{item.dictName}}&nbsp;({{item.collectCount}})</span>
          <span class="switch g-pointer" @click="showTagLine=!showTagLine">
            {{showTagLine ? '更多' : '收起'}}
            <i :class="showTagLine?'el-icon-arrow-right':'el-icon-arrow-down'"></i>
          </span>
        </div>
      </div>

      <div class="sch">
        <div class="sch-type">级别 :</div>
        <div class="sch-content">
          <span v-for="(item,index) in searchLevelList" :key="index" @click="searchTag(item.dictCode,3,item.dictName)" :class="{'blue': listQuery.collectLevel === item.dictCode}">{{item.dictName}}&nbsp;({{item.collectCount}})</span>
        </div>
      </div>

      <div class="sch-last" v-if="showHilever">
        <div class="sch-type">高级选项 :</div>
        <div class="type-content">
          <el-form ref="form" :model="listQuery" label-width inline>
            <el-row :gutter="10">
              <el-col :xs="24" :sm='8' :xl="4" :md="4" v-if=" pageType!=='6'">
                <el-form-item>
                  <el-cascader ref="myCascader" v-model="listQuery.collectTexture" placeholder="质地类别" :props="{ value: 'dictCode', label: 'dictName',checkStrictly: true }" :options="collectTextureList" :show-all-levels="false" @visible-change="clickOption(4,listQuery.collectTexture,collectTextureList, $event)"></el-cascader>
                  <!-- <el-select
                    v-model="listQuery.collectTexture"
                    placeholder="质地类别"
                    @change="clickOption(4,listQuery.collectTexture,collectTextureList)"
                  >
                    <el-option
                      v-for="item in collectTextureList"
                      :key="item.dictCode"
                      :label="item.dictName"
                      :value="item.dictCode"
                    ></el-option>
                  </el-select>-->
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm='8' :xl="4" :md="4">
                <el-form-item>
                  <el-select v-model="listQuery.collectDisablity" placeholder="完残程度" @change="clickOption(5,listQuery.collectDisablity,collectDisablity)">
                    <el-option v-for="item in collectDisablity" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col  :xs="24" :sm='8' :xl="4" :md="4" v-if="!$route.query.state && pageType!=='1'  && pageType!=='6'">
                <el-form-item>
                  <el-select v-if="pageType!=='5'" v-model="listQuery.accountState" placeholder="建账状态" @change="clickOption(6,listQuery.accountState,accountState)">
                    <!-- <el-option label="全部" value = ''></el-option> -->
                    <el-option v-for="item in accountState" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
                  </el-select>
                  <el-select v-if="pageType==='5'" v-model="listQuery.enterStorgeState" placeholder="入库状态" @change="clickOption(6,listQuery.enterStorgeState,enterStorgeStateList)">
                    <!-- <el-option label="全部" value = ''></el-option> -->
                    <el-option v-for="item in enterStorgeStateList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm='8' :xl="4" :md="4">
                <el-form-item>
                  <el-select v-model="listQuery.source" placeholder="文物来源" @change="clickOption(7,listQuery.source,source)">
                    <el-option v-for="item in source" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm='8' :xl="4" :md="4">
                <el-form-item>
                  <el-select v-model="listQuery.qualityRange" placeholder="质量范围" @change="clickOption(8,listQuery.qualityRange,massRangeList)">
                    <el-option v-for="item in massRangeList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm='8' :xl="4" :md="4">
                <el-form-item>
                  <el-select v-model="listQuery.enterCollectRange" placeholder="入藏时间范围" @change="clickOption(9,listQuery.enterCollectRange,timeList)">
                    <el-option v-for="item in timeList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm='8' :xl="4" :md="4" v-if="pageType==='5'">
                <el-form-item>
                  <el-select v-model="listQuery.storgeId" placeholder="库房名称" @change="clickOption(10,listQuery.storgeId,storgeNameList)">
                    <el-option v-for="item in storgeNameList" :key="item.storgeId" :label="item.storgeName" :value="item.storgeId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <!-- 藏品状态 -->
              <el-col :xs="24" :sm='8' :xl="4" :md="4" v-if="pageType==='1'">
                <el-form-item>
                  <el-select v-model="listQuery.collectStatus" placeholder="藏品状态" @change="clickOption(11,listQuery.collectStatus,collectStatus)">
                    <el-option v-for="item in collectStatus" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <!-- 是否高清图 -->
              <el-col :xs="24" :sm='8' :xl="4" :md="4" v-if="pageType==='6'">
                <el-form-item>
                  <el-select v-model="listQuery.isHigh" placeholder="是否有高清图片" @change="clickOption(12,listQuery.isHigh,isHighList)">
                    <el-option v-for="item in isHighList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    // 1:藏品管理 2:总账 3:分类账 4:辅助账 5:入库 6:藏品公开列表
    pageType: {
      type: String,
      default: ''
    },
    showHilever: {
      type: Boolean,
      default: true
    }
  },
  // computed: {
  //   dictName() {
  //     let arr = []

  //     return arr
  //   }
  // },
  watch: {
    $route() {
      this.restTag()
    }
  },
  data() {
    return {
      showHead: true, // 是否显示头部
      // 定义搜索下拉框状态值
      collectTextureList: [], // 质地
      source: [], // 来源
      accountState: [
        { dictName: '未建账', dictCode: '0' },
        { dictName: '已建账', dictCode: '1' }
      ],
      enterStorgeStateList: [
        { dictName: '未入库', dictCode: '0' },
        { dictName: '已入库', dictCode: '1' }
      ],
      isHighList: [{ dictName: '否', dictCode: '0' }, { dictName: '是', dictCode: '1' }],
      collectDisablity: [], // 完残程度
      collectStatus: [], // 藏品状态
      massRangeList: [], // 质量范围
      timeList: [], // 入藏时间范围
      storgeNameList: [], // 库房名称

      dynamicTags: [],

      headTagChoosed: [], // 头部已选中标签
      searchTypeList: [], // 分类
      showTagLine: true, // 分类显示一行
      searchYearList: [], // 年代
      showYearLine: true, // 年代显示一行
      searchLevelList: [], // 级别
      // showLeveLine: true,     // 级别显示一行
      listQuery: {
        key: '', //	藏品名称
        collectTexture: '', //	藏品质地
        collectDisablity: '', //	完残程度
        accountState: this.$route.query.state || '', //	建账状态
        source: '', //	来源
        qualityRange: '', // 质量范围
        enterCollectRange: '', // 入藏时间范围
        collectType: '', //	文物类别
        collectYear: '', //	藏品年代
        collectLevel: '', //	藏品级别
        storgeId: '', //	库房Id
        enterStorgeState: '', // 入库状态
        collectStatus: '', // 藏品状态
        isHigh: ''
        // type: '',    //	分类别
        // mark: '',    //	藏品标签
      }
    }
  },
  methods: {
    init() {
      this.initSelect()
      this.getCollectTexture() // 获取藏品质地
      this.pageType === '5' && this.getStorgeNameList()
      this.getCollectTypeData()
      this.getCollectYearData()
      this.getCollectLevelData()
    },
    // 切换显示头部
    toggleShowHead() {
      this.showHead = !this.showHead
    },
    searchTag(code, type, name) {
      this.setHeadChoosed(type, code, name)
      if (type === 1) {
        this.listQuery.collectType = code
      } else if (type === 2) {
        this.listQuery.collectYear = code
      } else if (type === 3) {
        this.listQuery.collectLevel = code
      }
      this.getParams()
    },
    // 获取下拉状态多选择值
    initSelect() {
      this.$http
        .post('/collectDict/getSelectDataByArr', {
          arr: [
            'collection_come_from',
            'degree_disability',
            'mass_range',
            'time_frame',
            'manage_collection_status'
          ]
        })
        .then(res => {
          if (res.success) {
            var state = res.result
            this.source = state['collection_come_from']
            this.collectDisablity = state['degree_disability']
            this.massRangeList = state['mass_range']
            this.timeList = state['time_frame']
            this.collectStatus = state['manage_collection_status']
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 查询藏品质地
    getCollectTexture() {
      this.$http
        .post('/collectDict/getCascadeSelectDataByDictType', {
          dictType: 'collection_texture'
        })
        .then(res => {
          if (res.success) {
            this.collectTextureList = res.result
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 库房列表
    getStorgeNameList() {
      this.$http.get('/enterStorge/getStorgeList', {}).then(res => {
        this.storgeNameList = res.result
      })
    },
    // 获取分类
    getCollectTypeData() {
      this.$http
        .post('/account/getCollectTypeHead', {
          pageType: this.pageType, // 1:藏品管理 2:总账 3:分类账 4:辅助账 5:入库
          accountState: this.$route.query.state ? '1' : ''
        })
        .then(res => {
          this.searchTypeList = res.result
        })
    },
    // 获取年代
    getCollectYearData() {
      this.$http
        .post('/account/getCollectYearHead', {
          pageType: this.pageType, // 1:藏品管理 2:总账 3:分类账 4:辅助账 5:入库
          accountState: this.$route.query.state ? '1' : ''
        })
        .then(res => {
          this.searchYearList = res.result
        })
    },
    // 获取级别
    getCollectLevelData() {
      this.$http
        .post('/account/getCollectLevelHead', {
          pageType: this.pageType, // 1:藏品管理 2:总账 3:分类账 4:辅助账 5:入库
          accountState: this.$route.query.state ? '1' : ''
        })
        .then(res => {
          this.searchLevelList = res.result
        })
    },
    // 搜索项选中
    clickOption(type = '', value = '', chooseList = '', isClose) {
      let selectStr = '' // 选中字典项的名称
      if (type === 10) {
        // 库房
        selectStr = chooseList.filter(item => item.storgeId === value)[0]
          .storgeName
      } else if (type === 4) {
        if (!isClose && this.$refs.myCascader.getCheckedNodes().length) {
          // 质地类别
          let labelsArr = this.$refs.myCascader.getCheckedNodes()[0].pathLabels
          selectStr = labelsArr[labelsArr.length - 1]
        } else {
          return
        }
      } else {
        // 字典项
        selectStr = chooseList.filter(item => item.dictCode === value)[0]
          .dictName
      }
      if (type && value && chooseList) {
        this.setHeadChoosed(type, value, selectStr)
      }
      this.getParams()
    },
    // 同步标签
    setHeadChoosed(type, value, name) {
      if (!this.headTagChoosed.some(item => item.type === type)) {
        if (name) {
          this.headTagChoosed.push({ type, value, name })
        }
      } else {
        this.headTagChoosed.forEach(item => {
          if (item.type === type) {
            if (!name) {
              this.headTagChoosed.splice(this.headTagChoosed.indexOf(item), 1)
            } else {
              item.value = value
              item.name = name
            }
          }
        })
      }
    },
    getParams() {
      this.$emit('getParams', {
        ...this.listQuery,
        collectTexture:
          this.listQuery.collectTexture.length > 1
            ? this.listQuery.collectTexture[
            this.listQuery.collectTexture.length - 1
            ]
            : ''
      })
    },
    // tag标签删除方法
    handleClose(tag) {
      switch (tag.type) {
        case 0:
          this.listQuery.key = ''
          break
        case 1:
          this.listQuery.collectType = ''
          break
        case 2:
          this.listQuery.collectYear = ''
          break
        case 3:
          this.listQuery.collectLevel = ''
          break
        case 4:
          this.listQuery.collectTexture = ''
          break
        case 5:
          this.listQuery.collectDisablity = ''
          break
        case 6:
          this.listQuery.accountState = ''
          break
        case 7:
          this.listQuery.source = ''
          break
        case 8:
          this.listQuery.qualityRange = ''
          break
        case 9:
          this.listQuery.enterCollectRange = ''
          break
        case 10:
          this.listQuery.storgeId = ''
          break
        case 11:
          this.listQuery.collectStatus = ''
          break
        case 12:
          this.listQuery.isHigh = ''
          break
      }
      this.headTagChoosed.splice(this.headTagChoosed.indexOf(tag), 1)
      this.getParams()
    },
    goPhoto() {
      this.$router.push({
        path: '/photo/search'
      })
    },
    // 重置标签
    restTag() {
      this.headTagChoosed = []
      this.listQuery = {
        key: '', //	藏品名称
        collectTexture: '', //	藏品质地
        collectDisablity: '', //	完残程度
        accountState: this.$route.query.state || '', //	建账状态
        source: '', //	来源
        qualityRange: '', // 质量范围
        enterCollectRange: '', // 入藏时间范围
        collectType: '', //	藏品分类
        collectYear: '', //	藏品年代
        collectLevel: '', //	藏品级别
        storgeId: '', //	库房id
        collectStatus: '' // 藏品状态
        // type: '',    //	分类别
        // mark: '',    //	藏品标签
      }
      this.getCollectTypeData()
      this.getCollectYearData()
      this.getCollectLevelData()
      this.getParams()
    }
  },
  created() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.cmp-search-dict {
  border-radius: 4px;
  padding: 30px 30px 10px 30px;
  background: #fff;
  .search-head {
    position: relative;
    .switch {
      position: absolute;
      right: 0;
      top: 7px;
      font-size: 14px;
      line-height: 30px;
      color: $primary;
    }
    .btn-camera-box {
      top: 10px;
      position: relative;
      display: inline-block;
      padding: 0 20px;
      cursor: pointer;
      // border: 1px solid #ebedf2;
      // border-radius: 12px;
    }
    .btn-camera {
      // position: relative;
      display: inline-block;
      // position: absolute;
      // top: 0;
      // z-index: 3;
      width: 40px;
      height: 30px;
      background: url(~@images/btn-camera.svg) center center no-repeat;
      background-size: contain;
    }
  }
  .el-button.reset {
    width: auto !important;
    font-size: 14px;
  }
}
.blue {
  color: #018F78 !important;
}

.sch {
  position: relative;
  display: flex;
  padding: 10px 60px 10px 0;
  font-size: 14px;
  background-color: #fff;
  .sch-type {
    height: 20px;
    min-width: 75px;
    color: #9699a2;
    margin-top: 4px;
  }
  .sch-content {
    width: 1470px;
    // margin-top: 3px;
    line-height: 30px;
    &.fix-height {
      height: 30px;
      overflow: hidden;
    }
  }
  .type-content {
    display: flex;
    flex:1;
    // min-width: 790px;
  }
  .sch-content span {
    padding-right: 20px;
    color: #575962;
    display: inline-block;
    cursor: pointer;
  }
  .switch {
    padding-right: 0 !important;
    color: #018F78 !important;
    position: absolute;
    right: 0;
    top: 10px;
  }
}
.sch-last {
  display: flex;
  font-size: 14px;
  padding-top: 10px;
  background-color: #fff;
  .type-content {
    display: flex;
    min-width: 790px;
  }
  .sch-type {
    height: 20px;
    min-width: 75px;
    color: #9699a2;
    line-height: 40px;
  }
}
.sch-top {
  line-height: 24px;
  padding-bottom: 0;
  min-height: 44px;
  box-sizing: border-box;
}
.total-type {
  color: #9699a2;
  // margin-top: 3px;
  min-width: 75px;
}
// 多表联动 标签颜色
.tag {
  height: 24px;
  // width: 100%;
  line-height: 22px;
  border-radius: 12px;
  margin-right: 6px;
  background-color: #fff;
  border-color: $primary;
}
</style>

